import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    failed: {
        id: 'cards.status.failed',
        defaultMessage: 'Card issuance failed. Please contact support for assistance.',
    },
    blocked: {
        id: 'cards.status.blocked',
        defaultMessage: 'This card has been permanently blocked. For assistance, contact support.',
    },
    pending: {
        id: 'cards.status.pending',
        defaultMessage: 'Your card is being issued. This may take a few minutes. Need help? Contact support.',
    },
    zeroBalance: {
        id: 'cards.status.zero_balance',
        defaultMessage: 'No funds on your card. Top up your card to start spending',
    },
    underZeroBalance: {
        id: 'cards.status.under_zero_balance',
        defaultMessage:
            'Please note that your balance is negative. Your card may be blocked, so please top it up. For all questions, please <a href="{supportLink}" target="_blank">contact support</a>.',
    },
    contact: {
        id: 'cards.status.contact',
        defaultMessage: 'Contact support',
    },
    topUp: {
        id: 'cards.status.top_up',
        defaultMessage: 'Top up',
    },
})
